import React, { lazy, Suspense } from "react";
import Pageloader from "Component/Loader/page";

const AssetsComp = lazy(() => import("./Assets"));
const C = (p) => <Suspense fallback={<Pageloader />}>{p.Child}</Suspense>;
const Assets = (p) => <C Child={<AssetsComp {...p} />} />;

export default Assets;
